import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const RemainingStep = () => _jsx("div", { className: 'step-menu-circle' });
export default RemainingStep;
